module.exports = __webpack_public_path__ + "static/media/help-circle-red.aceca097.svg";